class CaptionTimeValidator {
    constructor() {
        
    }
 
    isOverlapping(caption, captions) {
        return captions.filter(c => c.frameEnd > c.frameStart)
            .find(c =>  
                c.frameStart <= caption.frameStart && caption.frameStart <= c.frameEnd || 
                c.frameStart <= caption.frameEnd && caption.frameEnd <= c.frameEnd || 
                caption.frameStart <= c.frameStart && c.frameStart <= caption.frameEnd ||
                caption.frameStart <= c.frameEnd && c.frameEnd  <= caption.frameEnd
            ) != null;
    }
}
module.exports = new CaptionTimeValidator();



// WEBPACK FOOTER //
// ./app/helpers/caption-time-validator.js